module.exports = __webpack_public_path__ + "static/img/card.617cb75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/card.jpg
// module id = wBfv
// module chunks = 18